import { authRoles } from "../../auth/authRoles";
import EditProvinsi from "./EditProvinsi";
import Provinsi from "./Provinsi";
import TambahProvinsi from "./TambahProvinsi";

const provinsiRoutes = [
  {
    path: "/provinsi/edit/:id",
    exact: true,
    component: EditProvinsi,
    auth: authRoles.all,
  },
  {
    path: "/provinsi/tambah",
    exact: true,
    component: TambahProvinsi,
    auth: authRoles.all,
  },
  {
    path: "/provinsi",
    exact: true,
    component: Provinsi,
    auth: authRoles.all,
  },
];

export default provinsiRoutes;
